module.exports = __webpack_public_path__ + "static/coming-soon-ccbdcb5f1cac9046216e91c5f0048050.png";